import { cn } from '@/lib/utils'
import { type ReactNode } from 'react'

interface FixedMobileBottomBarProps {
  children: ReactNode
  className?: string
}

export function FixedMobileBottomBar({ children, className }: FixedMobileBottomBarProps) {
  return (
    <div
      className={cn(
        'fixed inset-x-0 bottom-0 z-40 flex min-h-20 items-center border-t border-slate-200 bg-white p-4 pb-[calc(env(safe-area-inset-bottom)+1rem)] lg:hidden',
        className,
      )}
    >
      <div className="flex-1">{children}</div>
    </div>
  )
}
